import useSWR, { mutate } from 'swr'
import useMutation from 'use-mutation'
import { post, get } from 'api/api'
import { Booking, Cancellation, NewBooking, UpdatedBooking } from 'api/types'

export const useBookings = () => useSWR<Booking[]>('/bookings', get)

export const useBooking = (bookingId: number) =>
  useSWR<Booking>(`/bookings/${bookingId}`, get)

const createBooking = ({ booking }: { booking: NewBooking }) =>
  post<Booking>(`/bookings`, booking)

export const useCreateBooking = () =>
  useMutation(createBooking, {
    onSuccess() {
      mutate('/bookings')
    },
  })

const updateBooking = ({
  bookingId,
  booking,
}: {
  bookingId: number
  booking: UpdatedBooking
}) => post<Booking>(`/bookings/${bookingId}`, booking, { method: 'PATCH' })

export const useUpdateBooking = () =>
  useMutation(updateBooking, {
    onSuccess({ input: { bookingId } }) {
      mutate(`/bookings`)
      mutate(`/bookings/${bookingId}`)
    },
  })

const cancelBooking = ({
  bookingId,
  bookingReason,
}: {
  bookingId: number
  bookingReason: string
}) =>
  post<Cancellation>(`/bookings/${bookingId}/cancel`, {
    cancellation_reason: `${bookingReason}`,
  })

export const useCancelBooking = () =>
  useMutation(cancelBooking, {
    onSuccess({ input: { bookingId } }) {
      mutate(`/bookings`)
      mutate(`/bookings/${bookingId}`)
    },
  })
